module.exports = __webpack_public_path__ + "static/img/SENCE.dc2aa7e3.png";